// HATV section Q month Upline Impact API

import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

export const hatvQmonthUplineImpactAPI = createApi({
    reducerPath: "HATVQUplineImpactAPI",
    baseQuery: axiosBaseQuery({
        baseUrl: config?.appUrl,
    }),
    // tagTypes: ["uplineimpact"],
    endpoints: (builder) => ({
        getHATVQMonthUplineImpact: builder.query<any, HATVAboStatisticParams>({
            query: ({ closingMonth, affiliateCode, aboNumber }) => ({
                url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/uplineimpact/gar/month/${closingMonth}`,
                method: "GET",
            })
        }),
        getHATVQMonthUplineMarketImpact: builder.query<any, HATVAboStatisticParams>({
            query: ({ closingMonth, affiliateCode, aboNumber }) => ({
                url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/uplineimpact/inmarket/month/${closingMonth}`,
                method: "GET",
            })
        }),
        getHATVBCRInfoList: builder.query<any, UserSpecificArgTypes>({
            query: ({ affiliateCode, aboNumber }) => ({
                url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/bcrs/active`,
                method: "GET",
            })
        }),
    }),
});

export const {
    useLazyGetHATVQMonthUplineImpactQuery,
    useLazyGetHATVQMonthUplineMarketImpactQuery,
    useGetHATVBCRInfoListQuery,
} = hatvQmonthUplineImpactAPI;